<template>
    <div class="finale">
        <div class="results-box">
            <h1>Your Boundary Balance</h1>
            <medal
                :medalType="getStakeholderMedal.medal"
                :medalKey="getStakeholderMedal.key"
                :medalInfo="getStakeholderMedal.description"
                :medalLabel="getStakeholderMedal.label"
            />
        </div>
        
        <h2 class="title-section">Business Results</h2>
        <div class="row result-row">
            <div class="col c24">
                <div class="results-box" >
                    <img src="img/boundaries/matrix-leadership-levers.png" />
                    <br />
                    <p>You chose <strong>{{content.LP}}</strong> action(s) to share your leadership perspective, <strong>{{content.OM}}</strong> action(s) to create an effective operating model, and <strong>{{content.DR}}</strong> action(s) to develop relationships in the Neon4  business</p>
                    <p>Leaders who utilize all three levers are most successful at building a foundation for collaboration in their organization.  If your scores are balanced, you understand the core levers for working across boundaries, and you should focus on implementing them!  If you chose levers mostly in one or two categories, you might want to explore the area(s) that you didn’t choose to better understand the value of the lever and how to implement it. The Resource pages can help.</p>  
                </div>
            </div>
        </div>
        
        <div class="learnapply">
            <h3>Learn and Apply</h3>
            <p>Continue developing your business prowess by viewing our <a href="https://portal.insightxp.com/portal.html?space=itg" target="_blank">resources to hone your skills</a>.</p>
        </div>
        <div class="sticky-footer">
            <button @click="replay" class="btn center noselect">Replay</button>
        </div>
        
        <div id="featureBackground" class="confetti"></div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { gsap } from '/src/assets/js/gsap'
import { ScrollToPlugin } from '/src/assets/js/gsap/ScrollToPlugin'
import { Physics2DPlugin } from '/src/assets/js/gsap/Physics2DPlugin'
import axios from 'axios';

// import Badge from '@/components/Badge.vue'
import Medal3 from '@/components/Medal3.vue'

var FormData = require('form-data');

export default {
    name: "Complete",
    components : {
        'medal': Medal3
    },
    computed: {
        ...mapGetters([
            "getState",
            "getUserType",
            "getSimName",
            "playerSelectionCounts",
            "getStakeholderMedal"
        ]),
        content(){
            return this.playerSelectionCounts.primary
        }
    },
    mounted () {
        gsap.registerPlugin(ScrollToPlugin, Physics2DPlugin);
        this.$parent.appHeight();
        gsap.to(window, {duration: 0.5, scrollTo: 0, delay: .2, ease: "sine.inOut"});
        this.doConfetti();
        this.setEndTime();
        // if production, send data to IE
        if( process.env.NODE_ENV === 'production') {
            gsap.delayedCall(0.75, this.sendData); 
        }
    },
    methods: {
        ...mapActions([
            "setEndTime",
            'reset'
        ]),
        replay() {
            // animate out, then reset, 
            gsap.to('.finale', {autoAlpha: 0, duration: 0.5, ease: "sine.inOut"})
            gsap.delayedCall(0.75, this.reset);
            gsap.delayedCall(1, this.goHome);
        },
        goHome() {
            this.$router.push({ path: "/" });
        },
        sendData () {
            var data = new FormData();
            var payload = JSON.stringify(this.getState);
            data.append('value', payload);

            var config = {
                method: 'post',
                url: `https://engine.insightxp.com/pdata?sim=${this.getSimName}&key=${this.getUserType}`,
                data : data
            };

            axios(config)
                .then(function (response) {
                    // console.log(JSON.stringify(response.data));
                })
                .catch(function (error) {
                    // console.log(error);
                });

        },
        doConfetti() {
            let dots = [],
            bg = document.querySelector("#featureBackground"),
            i, dot;

            // create 80 dot elements and put them in an array
            for (i = 0; i < 80; i++) {
                dot = document.createElement("div");
                    dot.setAttribute("class", "dot");
                    bg.appendChild(dot);
                    dots.push(dot);
            }

            //set the initial position of all the dots, and pick a random color for each from an array of colors
            gsap.set(dots, {
                backgroundColor: "random([#01aded, #f45537, #b4d236, #f08fae, #f5a421])",
                scale: "random(0.1, 0.35)",
                skewX: "random(20, 50)",
                height: "random(10px, 50px)",
                transformOrigin: 'center center',
                x: '50vw',
                y: '-20vh'
            });

            // create the physics2D animation
            gsap.to(dots, {
                duration: 5,
                rotation: "random(0, 5) * 360 + random(0, 360)",
                physics2D: {
                    velocity: 20,
                    angle: "random(0, 180)",
                    gravity: 50,
                },
                delay: "random(0, 1.5)"
            });
        }
    }
};
</script>